// Loaded from product-information-blocks.liquid. Guard against a second copy
// being injected (section re-render, app, or a stray include) — this file wires
// top-level listeners, so running twice doubles every click.
if (window.__onzSwatchInit) {
  console.warn('custom-swatch.js already initialised — skipping duplicate load');
} else {
  window.__onzSwatchInit = true;

document.addEventListener("DOMContentLoaded", function () {
  const materialButtons = document.querySelectorAll(".custom-swatch-mate-btn");
  const sizeContainer = document.querySelector(".custom-swatch-size-buttons");
  const sizeButtons = document.querySelectorAll(".custom-size-btn");
  const selectedMaterialText = document.getElementById("selected-material-text");
  const selectedSizeText = document.getElementById("selected-size-text");

  function updateSelectedSwatchImage() {
    const activeSizeButton = document.querySelector(".custom-size-btn.active");
    if (activeSizeButton) {
      const selectedImage = activeSizeButton.getAttribute("data-image-selected");
      const defaultImage = activeSizeButton.getAttribute("data-image");
      const imgElement = activeSizeButton.querySelector(".custom-size-image");

      if (selectedImage && selectedImage !== "null") {
        imgElement.src = selectedImage;
      } else {
        imgElement.src = defaultImage;
      }
    }
  }

  function applyInitialBorderColor() {
    const activeButton = document.querySelector(".custom-swatch-mate-btn.active");
    if (activeButton) {
      const selectedBorderColor = activeButton.getAttribute("data-border-color");
      activeButton.style.borderColor = selectedBorderColor;
    }
  }

  materialButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedMaterial = this.getAttribute("data-material");
      const selectedBorderColor = this.getAttribute("data-border-color");

      selectedMaterialText.textContent = selectedMaterial;

      materialButtons.forEach((btn) => {
        btn.classList.remove("active");
        btn.style.borderColor = "transparent";
      });
      this.classList.add("active");
      this.style.borderColor = selectedBorderColor;

      updateSizeSwatches(selectedMaterial);
      sizeContainer.classList.remove("custom-hidden");
    });
    applyInitialBorderColor();
  });

  function updateSizeSwatches(selectedMaterial) {
    sizeButtons.forEach((button) => {
      if (button.getAttribute("data-material") === selectedMaterial) {
        button.classList.remove("custom-hidden");
      } else {
        button.classList.add("custom-hidden");
      }
    });
  }

  const currentProductId = document.querySelector(".custom-size-btn.active")?.getAttribute("data-product-id");

  sizeButtons.forEach((button) => {
    const productId = button.getAttribute("data-product-id");
    const isActive = productId === currentProductId;

    if (isActive) {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  });

  // The product URL is rendered server-side onto each button
  // (data-product-url). The old path asked the Storefront GraphQL API for the
  // handle on every click — a blocking round trip that ended in alert("Error")
  // whenever it failed, and it shipped a hardcoded access token.

  sizeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const productId = this.getAttribute("data-product-id");
      const selectedSize = this.getAttribute("data-size");
      const selectedImage = this.getAttribute("data-image-selected");
      const defaultImage = this.getAttribute("data-image");

      selectedSizeText.textContent = selectedSize;

      sizeButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      const imgElement = this.querySelector(".custom-size-image");
      if (selectedImage && selectedImage !== "null") {
        imgElement.src = selectedImage;
      } else {
        imgElement.src = defaultImage;
      }

      updateSelectedSwatchImage();

      const destination = this.dataset.productUrl;
      if (destination) {
        window.location.href = destination;
      } else {
        // No URL rendered for this swatch — stay put rather than dead-end the user.
        console.warn('custom-swatch: no data-product-url on', this);
      }
    });

    button.addEventListener("mouseenter", function () {
      const hoverImage = this.getAttribute("data-image-selected");
      const imgElement = this.querySelector(".custom-size-image");

      if (hoverImage && hoverImage !== "null") {
        imgElement.src = hoverImage;
      }
    });

    button.addEventListener("mouseleave", function () {
      const imgElement = this.querySelector(".custom-size-image");

      if (this.classList.contains("active")) {
        const selectedImage = this.getAttribute("data-image-selected");
        if (selectedImage && selectedImage !== "null") {
          imgElement.src = selectedImage;
        }
      } else {
        const defaultImage = this.getAttribute("data-image");
        if (defaultImage) {
          imgElement.src = defaultImage;
        }
      }
    });

    button.addEventListener("click", function () {
      sizeButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      const selectedImage = this.getAttribute("data-image-selected");
      const imgElement = this.querySelector(".custom-size-image");
      if (selectedImage && selectedImage !== "null") {
        imgElement.src = selectedImage;
      }
    });
  });

  updateSelectedSwatchImage();
  
  const activeMaterialButton = document.querySelector(".custom-swatch-mate-btn.active");
  if (activeMaterialButton) {
    updateSizeSwatches(activeMaterialButton.getAttribute("data-material"));
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll(".swatch-label");

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const selectedColor = this.querySelector(".swatch-color").style.getPropertyValue("--swatch-background");

      swatches.forEach((btn) => btn.classList.remove("active"));

      this.classList.add("active");

      this.querySelector(".swatch-color").style.borderColor = selectedColor;
    });
  });
});

}
